import { triggerProactiveRefresh } from '../../interceptor/axios_interceptor'

let refreshTimer: NodeJS.Timeout | null = null

/**
 * Starts a proactive token refresh timer that calls /api/auth/refresh every 10 minutes
 * This keeps the access token valid before it expires (15 min lifetime, 5 min buffer)
 */
export function startTokenRefreshTimer() {
  // Clear any existing timer first
  stopTokenRefreshTimer()

  console.log('[AUTH] Starting proactive refresh timer (10 min interval)')

  refreshTimer = setInterval(async () => {
    console.log('[AUTH] Proactive refresh triggered')

    try {
      const response = await triggerProactiveRefresh()

      if (response.status === 200 && response.data) {
        console.log('[AUTH] Proactive refresh successful', {
          expiresIn: response.data.expiresIn,
          nextRefreshIn: '10 minutes'
        })
      } else {
        console.error('[AUTH] Proactive refresh failed', {
          status: response.status
        })
        stopTokenRefreshTimer()
        // Don't redirect here - let the axios interceptor handle 401s
      }
    } catch (error: any) {
      console.error('[AUTH] Proactive refresh error', error)
      // If the error is 401, the axios interceptor will handle logout
      // For network errors (e.g. waking from sleep), we DO NOT stop the timer
      // so it can retry on the next interval.
    }
  }, 10 * 60 * 1000) // 10 minutes in milliseconds
}

/**
 * Stops the proactive token refresh timer
 * Should be called on logout or when the timer is no longer needed
 */
export function stopTokenRefreshTimer() {
  if (refreshTimer) {
    console.log('[AUTH] Stopping proactive refresh timer')
    clearInterval(refreshTimer)
    refreshTimer = null
  }
}
